import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from "vuex";
import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { SELECTED_BOARD } from "@Broker/@Modules/clients/board/store/board-getters";
import { defineComponent } from "@vue/composition-api";
import { fullName } from "@Shared/@Utils/helpers/text";
export default defineComponent({
  name: "DuplicateClientWarningModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    profilesFound: {
      type: Array,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", [SELECTED_BOARD])), mapState("BoardStore", ["boards"])), {}, {
    matchingCaseToUse() {
      var _context;
      // Concatenate warning messages based on the matchingCases of each profile
      const concatMessage = _reduceInstanceProperty(_context = this.profilesFound).call(_context, (warningMessage, profile, index) => {
        if (index > 0) {
          warningMessage += "<br/><br/>";
        }
        if (profile.matchingCase === "email&fullName") {
          return warningMessage + this.$t("boards.messages.matchingEmailAndFullName", {
            boardName: profile.boardName,
            ownerName: fullName(profile.owner),
            fullName: fullName(profile),
            email: profile.email
          });
        }
        if (profile.matchingCase === "email") {
          return warningMessage + this.$t("boards.messages.matchingEmail", {
            fullName: fullName(profile),
            boardName: profile.boardName,
            ownerName: fullName(profile.owner),
            email: profile.email
          });
        }
        return warningMessage + this.$t("boards.messages.matchingFullName", {
          boardName: profile.boardName,
          ownerName: fullName(profile.owner),
          fullName: fullName(profile)
        });
      }, "");
      return concatMessage + this.$t("boards.messages.confirmToProceed");
    }
  }),
  methods: {
    createClient() {
      this.$emit("create-profile");
    },
    closingModal() {
      this.$emit("closing-modal");
    }
  }
});